import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../components/common/Modal';
import logo from '../../../../images/mg_logo.png';

import './InviteQrModal.scss';

const SIZE = 240;

// Drawn in the browser from the link itself, so every team gets its own code with nothing stored.
// The wordmark (624×180) sits across the middle; level H keeps the code scannable under it.
const InviteQrModal = ({ isOpen, onClose, inviteLink, teamName }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('team.qr.title')} className="InviteQrModal">
      <div className="qr-tile">
        <QRCodeSVG
          value={inviteLink}
          size={SIZE}
          level="H"
          marginSize={0}
          title={t('team.qr.join', { team: teamName })}
          imageSettings={{
            src: logo,
            width: Math.round(SIZE * 0.42),
            height: Math.round(SIZE * 0.42 * (180 / 624)),
            excavate: true,
          }}
        />
      </div>
      <p className="caption">{t('team.qr.caption', { team: teamName })}</p>
    </Modal>
  );
};

export default InviteQrModal;
